"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Link = require("./Link");
require("./Item.scss");
var Item = function Item(_ref) {
  var className = _ref.className,
    link = _ref.link;
  var Link = Item.Link;
  var jsxElement = link.jsxElement;
  var rootClassName = (0, _classnames["default"])('cds-Dropdown-ListItem', {
    'cds-Dropdown-ListItem--JsxElement': !!jsxElement
  }, className);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: rootClassName
  }, jsxElement || /*#__PURE__*/_react["default"].createElement(Link, link));
};
exports.Item = Item;
Item.Link = _Link.Link;